const ChooseReferencial = () =>
  import(
    /* webpackChunkName: "ChooseReferencial" */ "@/components/rapsotec/referencials/ChooseReferencial.vue"
  );
const RapsotecReferencial = () =>
  import(
    /* webpackChunkName: "RapsotecReferencial" */ "@/components/rapsotec/referencials/RapsotecReferencial.vue"
  );

const ReferentialHistory = () =>
  import(
    /* webpackChunkName: "ReferentialHistory" */ "@/components/rapsotec/referencials/ReferentialHistory.vue"
  );

const REFERENCIALS_ROUTE_NAME = "referencials";

export { REFERENCIALS_ROUTE_NAME };

export default [
  {
    path: "",
    name: REFERENCIALS_ROUTE_NAME,
    component: ChooseReferencial,
  },
  {
    path: "rapsotec-referencial",
    name: "rapsotec-referencial",
    component: RapsotecReferencial,
  },
  {
    path: "history",
    name: "referential-history",
    component: ReferentialHistory,
  },
];
